import moment from 'moment';

export default {
  methods: {
    getDateRange(daysSelected, dateFormat, type) {
      const dateRange = {};
      const date = moment();
      switch (daysSelected) {
        case 'isLast30Days':
          dateRange.startDate = moment()
            .subtract(30, 'days')
            .utc()
            .format(dateFormat);
          dateRange.endDate = moment()
            .utc()
            .format(dateFormat);
          break;
        case 'isLastYear':
          dateRange.startDate = moment()
            .subtract(365, 'days')
            .utc()
            .format(dateFormat);
          dateRange.endDate = moment()
            .utc()
            .format(dateFormat);
          break;
        case 'isThisMonth':
          dateRange.startDate = new Date(moment().format('YYYY-MM-01')).toISOString();
          dateRange.endDate = new Date(moment().format('YYYY-MM-')
            + moment().daysInMonth()).toISOString();
          break;
        case 'isNext3Months':
          dateRange.startDate = new Date(moment(moment().add(1, 'months')).format('YYYY-MM-01')).toISOString();
          // eslint-disable-next-line no-case-declarations
          const after3Months = moment().add(3, 'months');
          dateRange.endDate = new Date(moment(after3Months).format('YYYY-MM-')
            + moment().daysInMonth()).toISOString();
          break;
        case 'isNext30Days':
          dateRange.startDate = moment().add(1, 'days').format('YYYY-MM-DD');
          dateRange.endDate = moment().add(30, 'days').format('YYYY-MM-DD');
          break;
        case 'isNext6Months':
          dateRange.startDate = moment(moment().add(1, 'months')).format('YYYY-MM-01');
          // eslint-disable-next-line no-case-declarations
          const futureDate = moment().add(6, 'months');
          dateRange.endDate = moment(futureDate).format('YYYY-MM-') + futureDate.daysInMonth();
          break;
        case 'isThisYear':
          if (type === 'records') {
            dateRange.startDate = new Date(moment().format('YYYY-MM-DD')).toISOString();
            dateRange.endDate = new Date(moment(date).year() + moment(date).format('-12-31')).toISOString();
          } else {
            dateRange.startDate = moment(date).year() + moment(date).format('-01-01');
            dateRange.endDate = moment(date).year() + moment(date).format('-12-31');
          }
          break;
        case 'isNextYear':
          dateRange.startDate = moment(date).year() + 1 + moment(date).format('-01-01');
          dateRange.endDate = moment(date).year() + 1 + moment(date).format('-12-31');
          break;
        case 'isExpiringIn30Days':
          dateRange.startDate = moment().format('YYYY-MM-DD');
          dateRange.endDate = moment().add(30, 'days').format('YYYY-MM-DD');
          break;
        case 'isExpiringIn30To45Days':
          dateRange.startDate = moment().add(31, 'days').format('YYYY-MM-DD');
          dateRange.endDate = moment().add(45, 'days').format('YYYY-MM-DD');
          break;
        default:
          dateRange.startDate = moment()
            .subtract(7, 'days')
            .utc()
            .format(dateFormat);
          dateRange.endDate = moment()
            .utc()
            .format(dateFormat);
          break;
      }
      return dateRange;
    },
  },
};
